import React from 'react'
import { CreateSupportAnnounce5Container } from '../../containers/Officer/CreateSupportAnnounce5Container'
export const CreateSupportAnnounce5Page = () => {
    return (
        <CreateSupportAnnounce5Container />
    )
}
